import * as React from 'react';
import * as qs from 'qs';

// Import { Block, Row } from 'emotion-jsxstyle';
import { EntityActions, EntityType } from 'common/entity';
// import { EntityActions } from 'common/entity';
import { toApiError } from 'common/utils/api';

import { AppState } from 'common/models/AppState';
// import { Badge } from 'common/components/Badge';
import { Card } from 'common/components/Card';
import { HistoryTabs } from 'common/components/HistoryTabs';
import { Loading } from 'common/components/Loading';
// import { MediaImage } from 'common/components/MediaImage';
// import { ChaptersDetailInfo } from './ChaptersDetailInfo';
import { Filter } from 'common/components/Filters';
import { Page } from 'common/components/layout/Page/Page';
import { RouteComponentProps } from 'react-router-dom';
import { TabPane } from 'reactstrap';
import { Chapter } from 'common/api/models/Chapter';
import { ChaptersDetailInfo } from 'src/screens/Chapters/ChaptersDetailInfo';
import { ChaptersDetailMembers } from 'src/screens/Chapters/ChaptersDetailMembers';
import { ChaptersDetailNotes } from 'src/screens/Chapters/ChaptersDetailNotes';
import { ChapterApi } from 'common/api/resources/ChapterApi';
import { Member } from 'common/api/models/Member';
import { MemberApi } from 'common/api/resources/Member2Api';
import { Filters } from 'common/components/Filters';
import { ChapterPositionApi } from 'common/api/resources/ChapterPositionApi';
import { ChapterPosition } from 'common/api/models/ChapterPosition';
import moment = require('moment');

export interface ChaptersDetailProps {
  appState: AppState;
  entityActions: EntityActions;
  id: string;
}

export interface ChaptersDetailState {
  isLoading: boolean;
  error?: string;
  chapter?: Chapter;
  admins?: Member[];
  members?: Member[];
  pastOfficers?: ChapterPosition[];
  activeTab: string;
  dialog?: string;
  dialogSuccess?: string;
  dialogError?: string;
  dialogLoading?: boolean;
  filters?: Filter[];
}

export class ChaptersDetail extends React.Component<
  ChaptersDetailProps & RouteComponentProps<{}>,
  ChaptersDetailState
> {
  state: ChaptersDetailState = { isLoading: false, chapter: {}, activeTab: 'info', filters: [] };
  filterNames = ['year', 'position'];
  filterArray: Filter[] = [];
  componentDidMount() {
    this.reload(this.props.id);
  }

  // componentDidUpdate(prevProps: ChaptersDetailProps) {
  //   if (prevProps.id !== this.props.id || prevProps.reloadAt !== this.props.reloadAt) {
  //     this.reload(this.props.id);
  //   }
  // }

  reload(id: string) {
    this.setState({ isLoading: true });
    ChapterApi.getChapter(id).then(
      chapter => {
        this.props.entityActions.put(EntityType.CHAPTER, chapter.id!, chapter);
        this.props.entityActions.fetch(EntityType.CHAPTER, chapter.createId!);
        this.props.entityActions.fetch(EntityType.CHAPTER, chapter.updateId!);
        Promise.all([MemberApi.getMembersByChapterId(chapter.id!, 'ADMINS')]).then(
          ([memberRes]) => {
            this.setState({ admins: memberRes.data });
          },
          err => {
            this.setState({ error: toApiError(err) });
          }
        );
        Promise.all([
          ChapterPositionApi.getChapterMembers({
            chapterId: chapter.id!,
            roleName: Member.ChapterRole.OFFICER,
            startDate: moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00Z',
            // endDate: moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00Z'
            endDate: new Date().getFullYear() + '-12-31T23:59:59Z',
          }),
        ]).then(
          ([memberRes]) => {
            this.setState({ chapter, members: memberRes.data });
          },
          err => {
            this.setState({ error: toApiError(err) });
          }
        );
        this.filterArray.push({
          name: 'year',
          label: 'Year',
          options: [],
        });

        this.filterArray.push({
          name: 'position',
          label: 'Position',
          options: [],
        });
        Promise.all([ChapterPositionApi.getChapterYearsPositions(chapter.id!, 'years')]).then(
          ([yearsRes]) => {
            let yearsArray = [{ label: 'All', value: '' }];
            yearsRes.reverse().forEach((item: string) => {
              const value = item.toString().replace(/ /g, '_');
              yearsArray.push({ label: item, value: value });
            });
            this.filterArray[0].options = yearsArray;
            this.setState({ filters: this.filterArray });
          },
          err => {
            this.setState({ error: toApiError(err) });
          }
        );
        Promise.all([ChapterPositionApi.getChapterYearsPositions(chapter.id!, 'positions')]).then(
          ([positionRes]) => {
            let posArray = [{ label: 'All', value: '' }];
            positionRes.forEach((item: string) => {
              const value = item.toString().replace(/ /g, '_');
              posArray.push({ label: item, value: value });
            });
            this.filterArray[1].options = posArray;
            this.setState({ filters: this.filterArray });
          },
          err => {
            this.setState({ error: toApiError(err) });
          }
        );

        const q = qs.parse(this.props.location.search.substring(1)).q;
        this.getPastOfficers(q);
      },
      err => {
        this.setState({ error: toApiError(err) });
      }
    );
  }
  getPastOfficers(query: any) {
    const filterObj: Partial<ChapterPosition> = {};

    if (!query) {
      filterObj.chapterId = this.props.id;
      filterObj.roleName = Member.ChapterRole.OFFICER;
    } else {
      const queryObj = {} as any;
      query.split(' ').forEach((item: String) => {
        const arr = item.split(':');
        queryObj[arr[0]] = arr[1].replace(/_/g, ' ');
      });

      filterObj.chapterId = this.props.id;
      filterObj.roleName = Member.ChapterRole.OFFICER;
      if (queryObj.position) {
        filterObj.positionName = queryObj.position;
      }
      if (queryObj.year) {
        filterObj.startDate = queryObj.year + '-01-01T00:00:00Z';
        filterObj.endDate = queryObj.year + '-12-31T23:59:59Z';
      } else {
        const year = new Date().getFullYear();
        filterObj.endDate = year - 1 + '-12-30T23:59:59Z';
      }
    }

    ChapterPositionApi.getChapterPositions(filterObj).then(
      members => {
        this.setState({ pastOfficers: members.data, isLoading: false });
      },
      err => {
        console.log(err);
      }
    );
  }
  handleQuery = (query: string) => {
    if (!query) {
      this.props.history.push(this.props.location.pathname);
    } else {
      this.props.history.push(this.props.location.pathname + '?' + qs.stringify({ q: query }));
    }
    this.getPastOfficers(query);
  };
  getQuery() {
    const q = qs.parse(this.props.location.search.substring(1)).q;
    return q !== undefined ? q : '';
  }
  render() {
    // const entities = this.props.appState.entities;
    const chapter = this.state.chapter!;
    const members = this.state.members!;
    const filters = this.state.filters!;
    const admins = this.state.admins!;
    const pastOfficers = this.state.pastOfficers!;

    const query = this.getQuery();

    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    }
    if (this.state.isLoading || !chapter) {
      return <Loading />;
    }

    // const member = chapter.id ? entities.member[chapter.id] : undefined;

    let tabs = [
      { name: 'info', label: 'Info' },
      { name: 'members', label: 'Officers' },
      { name: 'notes', label: 'Notes' },
    ];

    return (
      <Page
        title={chapter.name + ''}
        breadcrumbs={[{ label: 'Chapters', to: '/chapters' }]}
        history={this.props.history}
      >
        <Card padding="1rem" marginBottom="2rem">
          <HistoryTabs
            tabs={tabs}
            history={this.props.history}
            location={this.props.location}
            basePath={'/chapters/' + chapter.id}
          >
            <TabPane tabId="info">
              <ChaptersDetailInfo chapter={chapter} appState={this.props.appState} members={members} admins={admins} />
            </TabPane>
            <TabPane tabId="members">
              <div className="mt-3">
                <Filters value={query} filters={filters} onChange={this.handleQuery} />
              </div>
              <ChaptersDetailMembers
                chapter={chapter}
                members={pastOfficers}
                // search={query}
                appState={this.props.appState}
                entityActions={this.props.entityActions}
              />
            </TabPane>
            <TabPane tabId="notes">
              {chapter.id && (
                <ChaptersDetailNotes
                  chapter={chapter}
                  appState={this.props.appState}
                  entityActions={this.props.entityActions}
                  entityId={chapter.id!}
                />
              )}
            </TabPane>
          </HistoryTabs>
        </Card>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Chapters/ChaptersDetail.tsx